import { authRoutes, dashboardRoutes, mainRoutes, profileRoutes } from './routes';
import { NamedUrl } from './types';

export class RouteProvider {
  getUrls(): Array<NamedUrl> {
    return [
      ...mainRoutes,
      ...this.withPrefix('dashboard', [
        ...dashboardRoutes,
        ...this.withPrefix('profile', profileRoutes),
      ]),
      ...this.withPrefix('auth', [...authRoutes]),
    ];
  }

  private withPrefix(prefix: string, urls: Array<NamedUrl>): Array<NamedUrl> {
    return urls.map((url) => {
      return { ...url, url: `/${prefix}${url.url}` };
    });
  }
}
